export const SWIFTFOX_PALETTE = {
	blue: {
		'05-glacialAir': '#F7FAFF',
		'10-icyMist': '#EEF4FF',
		'20-frostedAzure': '#B4CFFF',
		'30-skywave': '#6C9BF1',
		'40-coreBlue': '#2F68D1',
		'50-deepOcean': '#1F458B',
		'60-midnight': '#0B1E41'
	},
	orange: {
		'10-apricotCream': '#FFEBD9',
		'20-goldenSand': '#FFD2A8',
		'30-highlight': '#FF9D43',
		'40-emberBaze': '#D96C08',
		'50-espresso': '#6E3602'
	},
	neutral: {
		'10-almostWhite': '#FDFDFF',
		'20-offWhite': '#F7F7F9',
		'30-lightGrey': '#E7E7EB',
		'40-justGrey': '#D0D0D4',
		'50-midGrey': '#8F8F91',
		'60-darkGrey': '#48484A',
		'70-nearlyBlack': '#1C1C1E'
	},
	green: {
		'10-mintFrost': '#E0FFCF',
		'20-springMist': '#C7F89F',
		'30-springGreen': '#A3F065',
		'40-meadowLight': '#7FCF3E',
		'50-freshMeadow': '#3E7D1C'
	},
	magenta: {
		'10-lavendar': '#FFCCE0',
		'20-blushPetal': '#FFADCD',
		'30-roseQuartz': '#FF72A8',
		'40-crimsonRose': '#C84175',
		'50-berryWine': '#9C2351'
	},
	purple: {
		'10-lilacMist': '#EDD1FF',
		'20-softViolet': '#DEA8FF',
		'30-orchidGlow': '#BE6CF1',
		'40-royalBloom': '#9344C4',
		'50-amethyst': '#662091'
	},
	teal: {
		'10-arcticBreeze': '#D6FAFF',
		'20-coolSky': '#A4EEFC',
		'30-crystalBlue': '#69E7F9',
		'40-blueReef': '#3CB2C8',
		'50-oceanTeal': '#1D7681'
	},
	circles: {
		dark: '#622091',
		light: '#EDD1FF'
	},
	roles: {
		dark: '#3E7D1C',
		light: '#E0FFCF'
	}
};

const { blue, neutral, orange } = SWIFTFOX_PALETTE;

export const SWIFTFOX_GRADIENTS = {
	midnightHorizon: `linear-gradient(90deg, ${blue['60-midnight']} 0%, ${blue['40-coreBlue']} 100%)`,
	azureSkyline: `linear-gradient(90deg, ${blue['40-coreBlue']} 0%, #81ADFF 100%)`,
	sunsetGlow: `linear-gradient(90deg, ${orange['30-highlight']} 0%, ${orange['20-goldenSand']} 100%)`,
	polarDawn: `linear-gradient(90deg, ${blue['60-midnight']} 8.54%, #102B5B 16.19%, #163875 23.84%, #1D4590 31.48%, #2453AA 39.13%, #2B61C4 46.77%, #3F6FD5 54.42%, #6080DE 62.07%, #8497E6 69.71%, #AAB3EE 77.36%, #D2D5F7 85%, ${neutral['10-almostWhite']} 92.65%)`
} as const;
